import axios from 'axios'

axios.defaults.timeout =  6000;
axios.interceptors.request.use(data=> {
    return data;
  }, err=> {
    if (err.response) {
        switch (err.response.status) {
          case 400: 
            break;
          case 401: 
            break;
          case 404: 
            break;
          case 500: 
            break;
        }
      }
      if(error.code === 'ECONNABORTED' || error.message ===   "Network Error" ||  error.message.includes("timeout")){  
      Message({
        message: '请求超时，请稍后重试',
        type: "error",
        duration: 5 * 1000,
      })
    }
   return Promise.resolve(error.response);

    //return Promise.resolve(err);
  });
/*   export default axios; */
  export default {
    post (url, data,headers) {
      return axios({
        method: 'post',
        url,
        data: data,
        headers:headers
       
      })
    },
    get (url, params,headers) {
      return axios({
        method: 'get',
        url,
        params,
        headers:headers
      })
    }
  }


// WEBPACK FOOTER //
// ./src/api/index.js